import React, { useState, KeyboardEvent, ChangeEvent } from 'react';
import styles from '../../../../components/account/verification/TwoFactorAuthentication/TwoFactorAuthentication.module.scss';
import Icon from 'utils/components/icon';
import { VerifyCodeErrorType } from 'app/scripts/components/account/verification/TwoFactorAuthentication/TwoFactorAuthentication';

interface Props {
  onVerify: () => void;
  onChange: (code: string) => void;
  isFormDisabled: boolean;
  status: string;
  verifyCodeError: VerifyCodeErrorType;
}

export const VerificationInput: React.FC<Props> = ({
  onVerify,
  onChange,
  isFormDisabled,
  status,
  verifyCodeError
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const isStatusError = status === 'error' || status === 'networkError';

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onVerify();
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`${styles.verificationWrapper} `}>
      <input
        className={`${styles.verificationInput} ${isStatusError ? styles.error : ''} ${
          isFocused ? styles.focused : ''
        }`}
        type="text"
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={isFormDisabled}
      />
      {verifyCodeError === 'Invalid' && isStatusError && (
        <div>
          <Icon name="circle-bolded-error" className={styles.inputCircleError} />
          <div className={styles.errorMessage}>Invalid verification code</div>
        </div>
      )}
    </div>
  );
};
